import { create } from 'zustand';

export interface ServiceVariant {
	id?: string;
	size: string;
	length: string;
	duration: number;
	price: number;
}

export interface Service {
	id: string;
	name: string;
	variants: ServiceVariant[];
}

interface ServicesState {
	services: Service[];
	addService: (service: Service) => void;
	updateService: (id: string, service: Service) => void;
	deleteService: (id: string) => void;
}

const useServicesStore = create<ServicesState>(set => ({
	services: [
		{
			id: '1',
			name: 'Haircut & Style',
			variants: [
				{ id: '1-1', size: 'M', length: 'Shoulder', duration: 60, price: 75.0 },
				{ id: '1-2', size: 'L', length: 'Bra', duration: 75, price: 85.0 },
				{ id: '1-3', size: 'XL', length: 'Mid-Back', duration: 90, price: 95.0 },
			],
		},
		{
			id: '2',
			name: 'Full Color',
			variants: [
				{ id: '2-1', size: 'S', length: 'Shoulder', duration: 90, price: 120.0 },
				{ id: '2-2', size: 'M', length: 'Bra', duration: 120, price: 150.0 },
				{ id: '2-3', size: 'L', length: 'Waist', duration: 150, price: 180.0 },
				{ id: '2-4', size: 'XL', length: 'Butt', duration: 180, price: 210.0 },
			],
		},
		{
			id: '3',
			name: 'Highlights',
			variants: [
				{ id: '3-1', size: 'M', length: 'Shoulder', duration: 90, price: 120.0 },
				{ id: '3-2', size: 'L', length: 'Mid-Back', duration: 120, price: 145.0 },
			],
		},
	],

	addService: service =>
		set(state => ({
			services: [...state.services, service],
		})),

	updateService: (id, updatedService) =>
		set(state => ({
			services: state.services.map(s => (s.id === id ? updatedService : s)),
		})),

	deleteService: id =>
		set(state => ({
			services: state.services.filter(s => s.id !== id),
		})),
}));

export default useServicesStore;
